import React, { useState } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const FirebaseTest = () => {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const testFirestore = async () => {
    setLoading(true);
    setStatus('Testing Firestore connection...');

    try {
      // Test write
      setStatus('Writing test document...');
      const testRef = await addDoc(collection(db, 'test'), {
        message: 'Hello Firebase!',
        timestamp: new Date().toISOString()
      });
      setStatus(`✅ Write successful! Doc ID: ${testRef.id}`);

      // Test read
      setTimeout(async () => {
        setStatus('Reading test documents...');
        const snapshot = await getDocs(collection(db, 'test'));
        setStatus(`✅ Read successful! Found ${snapshot.size} documents`);
      }, 1000);

    } catch (error) {
      setStatus(`❌ Error: ${error.message}`);
      console.error('Firebase test error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
    className="firebase-test-component"
    style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <h3 style={{ margin: '0 0 10px 0' }}>Firebase Test</h3>
      <button
        onClick={testFirestore}
        disabled={loading}
        style={{
          padding: '10px 20px',
          background: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          width: '100%'
        }}
      >
        {loading ? 'Testing...' : 'Test Firestore'}
      </button>
      {status && (
        <div style={{
          marginTop: '10px',
          padding: '10px',
          background: '#f3f4f6',
          borderRadius: '4px',
          fontSize: '12px',
          wordBreak: 'break-word'
        }}>
          {status}
        </div>
      )}
    </div>
  );
};

export default FirebaseTest;
